export default {
    strict: true,
    fields: {
        email: {
            type: "string",
        },
    },
};
